import { useEffect, useRef, useState, useMemo, useCallback } from 'react';

export const useTextInputPresenter = ({
  value,
  placeholder,
  label,
  error,
  outerInputRef,
  disabled,
  onChange,
  onBlur,
  onFocus,
  onClear,
  validate,
}) => {
  const inputRef = useRef(null);

  const [isFocused, setIsFocused] = useState(false);
  const [inputError, setInputError] = useState('');

  const getInputRef = () => {
    return outerInputRef || inputRef;
  };

  const isActiveLabel = useMemo(() => {
    return isFocused || value !== '';
  }, [isFocused, value]);

  const getPlaceholder = useMemo(() => {
    return label ? (isFocused ? placeholder : '') : placeholder;
  }, [label, isFocused, placeholder]);

  const onHandleBlur = useCallback(
    (event) => {
      setIsFocused(false);

      const isClearButtonClick = event.relatedTarget?.closest('.clear-button-class');

      if (!isClearButtonClick) {
        if (validate) {
          validate();
        }
        onBlur(event);
      }
    },
    [validate, onBlur]
  );

  const onHandleFocus = useCallback(
    (event) => {
      setIsFocused(true);
      onFocus(event);
    },
    [onFocus]
  );

  const onHandleClear = useCallback(
    (event) => {
      if (!disabled) {
        event.preventDefault();
        event.stopPropagation();

        if (getInputRef().current) {
          getInputRef().current.value = '';
          setInputError('');
        }

        onChange({ target: { value: '' } });
        onClear();
      }
    },
    [disabled, onChange, getInputRef]
  );

  useEffect(() => {
    setInputError(error);
  }, [error]);

  return {
    inputError,
    isFocused,
    getInputRef,
    isActiveLabel,
    getPlaceholder,
    onHandleBlur,
    onHandleFocus,
    onHandleClear,
  };
};
